import React from 'react';
import { identity } from "../../../utils/getIdentity";
import './style.scss';

const SettingsToggler = ({ roleMode, setRoleMode, firstMode, secondMode, thirdMode }) => {
  return (
    <div className="role-mode-toggler-wrapper">
      <div className={`role-mode-toggler role-mode-toggler-${identity}`}>
        <span
          className={`role-mode-toggler__item ${roleMode === 'fee' && `active active-${identity}`}`}
          onClick={() => setRoleMode('fee')}
        >
          {firstMode}
        </span>
        <span
          className={`role-mode-toggler__item ${roleMode === 'role' && `active active-${identity}`}`}
          onClick={() => setRoleMode('role')}
        >
          {secondMode}
        </span>
        {/*{identity === 'inex' && (
          <span
            className={`role-mode-toggler__item ${roleMode === 'agent' && `active active-${identity}`}`}
            onClick={() => setRoleMode('agent')}
          >
          {thirdMode}
        </span>
        )}*/}
      </div>
    </div>
  )
};

export default SettingsToggler;